import { del, get, post, put } from "./api_helper";
import * as url from "./url_helper";

export const getLogging = (data) => post(url.LOGIN, data);
export const forgot = (data) => post(url.FORGOT, data);
export const verifyToken = (token) => get(url.VERIFY_TOKEN + token);
export const resetPassword = (token, data) => {
  return post(url.RESET + token, data);
};

//Groups Management

export const getGroup = (data) => {
  return post(url.GROUP, data);
};
export const changeGroupRequest = (data) => {
  return post(url.GROUP_REQUEST, data);
};
export const getGroupById = (id) => {
  return get(url.GROUP + "/" + id);
};
export const ListGroup = (data) => {
  return get(url.GROUP_LIST, data);
};
export const UpdateGroup = (data, id) => {
  return post(url.GROUP_UPDATE + id, data);
};
export const deleteGroup = (id) => {
  return del(url.GROUP_DELETE + id);
};
export const changeGroupStatus = (id, data) => {
  return post(url.GROUP_STATUS + id, data);
};

//Content Management
export const getContent = (data) => {
  return post(url.CONTENT, data);
};
export const Content = (id) => {
  console.log("id", id);
  return get(url.CONTENT_GET + id);
};
export const ListContent = (data) => {
  return get(url.CONTENT_LIST, data);
};
export const UpdateContent = (data, id) => {
  return post(url.CONTENT_UPDATE + id, data);
};
export const deleteContent = (id) => {
  return del(url.CONTENT_DELETE + id);
};
export const changeContentStatus = (id, data) => {
  return post(url.CONTENT_STATUS + id, data);
};

//email
export const getEmail = (data) => {
  return post(url.EMAIL, data);
};
export const ListEmail = (data) => {
  return get(url.EMAIL_LIST, data);
};
export const Email = (id) => {
  return get(url.EMAIL_GET + id);
};
export const UpdateEmail = (data, id) => {
  return post(url.EMAIL_UPDATE + id, data);
};
export const deleteEmail = (id) => {
  return del(url.EMAIL_DELETE + id);
};
export const changeEmailStatus = (id, data) => {
  return post(url.EMAIL_STATUS + id, data);
};

//notification
export const getNotification = (data) => {
  return post(url.NOTIFICATION, data);
};
export const getAdminNotification = (data) => {
  return get(url.NOTIFICATION_ADMIN, data);
};
export const ListNotification = (data) => {
  return get(url.NOTIFICATION_LIST, data);
};
export const Notification = (id) => {
  console.log("id", id);
  return get(url.NOTIFICATION_GET + id);
};
export const changeNotificationStatus = (id, data) => {
  return post(url.NOTIFICATION_STATUS + id, data);
};
export const deleteNotification = (payload) => {
  console.log("payload", payload);

  if (payload === "all") {
    return del(url.NOTIFICATION_ADMIN_DELETE + "/all-delete");
  } else {
    return del(url.NOTIFICATION_ADMIN_DELETE, { data: { ids: [payload] } });
  }
};
export const readNotification = (payload) => {
  if (payload === "all") {
    return get(url.NOTIFICATION_ADMIN_READ + "/all");
  } else {
    return get(url.NOTIFICATION_ADMIN_READ + "/" + payload);
  }
};
//customer management
export const getCustomer = (data) => {
  return post(url.CUSTOMER, data);
};
export const ListCustomer = (data) => {
  return get(url.CUSTOMER_LIST, data);
};
export const getCustomerById = (id) => {
  return get(url.CUSTOMER_LIST + "/" + id);
};
export const getCustomerJoinedBets = (id, filter) => {
  return get(url.JOINED_BET + id, filter);
};
export const getCustomerCreatedBets = (id, filter) => {
  return get(url.CREATED_BET + id, filter);
};
export const UpdateCustomer = (data, id) => {
  return post(url.CUSTOMER_UPDATE + id, data);
};
export const deleteCustomer = (id) => {
  return del(url.CUSTOMER_DELETE + id);
};
export const changeCustomerStatus = (id, data) => {
  return post(url.CUSTOMER_STATUS + id, data);
};

//wager management
export const addWager = (data) => {
  return post(url.WAGER, data);
};
export const ListWager = (data) => {
  return get(url.WAGER_LIST, data);
};
export const UpdateWager = (data, id) => {
  return post(url.WAGER_UPDATE + id, data);
};
export const deleteWager = (id) => {
  return del(url.WAGER_DELETE + id);
};
export const changeWagerStatus = (id, data) => {
  return post(url.WAGER_STATUS + id, data);
};

//Banner Management
export const addBanner = (data) => {
  return post(url.BANNER, data);
};
export const getBanner = (data) => {
  return get(url.BANNER_LIST, data);
};
export const UpdateBanner = (data, id) => {
  return post(url.BANNER_UPDATE + id, data);
};
export const deleteBanner = (id) => {
  return del(url.BANNER_DELETE + id);
};
export const changeBannerStatus = (id, data) => {
  return post(url.BANNER_STATUS + id, data);
};

//bet management
export const addBet = (data) => {
  return post(url.BET, data);
};
export const ListBet = (data) => {
  return get(url.BET_LIST, data);
};
export const getBet = (id, filter) => {
  return get(url.BET_GET + id, filter);
};
export const UpdateBet = (id, data) => {
  return post(url.BET_UPDATE + id, data);
};
export const deleteBet = (id) => {
  return del(url.BET_DELETE + id);
};
export const changeBetStatus = (id, data) => {
  return post(url.BET_STATUS + id, data);
};
export const setWinningOption = (id, data) => {
  return post(url.SET_WINNING_OPTION + id, data);
};

//category management

export const categories = {
  //category_level_1
  getCtgLv1: (data) => get(url.CATEGORY_LV1_LIST, data),
  addCtgLv1: (data) => post(url.CATEGORY_LV1, data),
  updateCtgLv1: (data, id) => post(url.CATEGORY_LV1_UPDATE + id, data),
  deleteCtgLv1: (id) => del(url.CATEGORY_LV1_DELETE + id),
  changeCtgLv1Status: (id, data) => post(url.CATEGORY_LV1_STATUS + id, data),
  //category_level_2
  getCtgLv2: (data) => get(url.CATEGORY_LV2_LIST, data),
  addCtgLv2: (data) => post(url.CATEGORY_LV2, data),
  updateCtgLv2: (data, id) => post(url.CATEGORY_LV2_UPDATE + id, data),
  deleteCtgLv2: (id) => del(url.CATEGORY_LV2_DELETE + id),
  changeCtgLv2Status: (data, id) => post(url.CATEGORY_LV2_STATUS + id, data),

  //category_level_3
  getCtgLv3: (data) => get(url.CATEGORY_LV3_LIST, data),
  addCtgLv3: (data) => post(url.CATEGORY_LV3, data),
  updateCtgLv3: (data, id) => post(url.CATEGORY_LV3_UPDATE + id, data),
  deleteCtgLv3: (id) => del(url.CATEGORY_LV3_DELETE + id),
  changeCtgLv3Status: (data, id) => post(url.CATEGORY_LV3_STATUS + id, data),

  //category_level_4
  getCtgLv4: (data) => get(url.CATEGORY_LV4_LIST, data),
  addCtgLv4: (data) => post(url.CATEGORY_LV4, data),
  updateCtgLv4: (data, id) => post(url.CATEGORY_LV4_UPDATE + id, data),
  deleteCtgLv4: (id) => del(url.CATEGORY_LV4_DELETE + id),
  changeCtgLv4Status: (data, id) => post(url.CATEGORY_LV4_STATUS + id, data),

  //category_level_5
  getCtgLv5: (data) => get(url.CATEGORY_LV5_LIST, data),
  addCtgLv5: (data) => post(url.CATEGORY_LV5, data),
  updateCtgLv5: (data, id) => post(url.CATEGORY_LV5_UPDATE + id, data),
  deleteCtgLv5: (id) => del(url.CATEGORY_LV5_DELETE + id),
  changeCtgLv5Status: (data, id) => post(url.CATEGORY_LV5_STATUS + id, data),
};

//profile management
export const getProfile = () => {
  return get(url.GET_PROFILE);
};
export const updateProfile = (data) => {
  return post(url.UPDATE_PROFILE, data);
};
export const changePassword = (data) => {
  return post(url.CHANGE_PROFILE, data);
};
export const changeEmail = (data) => {
  return post(url.CHANGE_EMAIL, data);
};

export const avatarList = (filter) => {
  return get(url.AVATAR_LIST, filter);
};
export const addAvatar = (data) => {
  return post(url.AVATAR, data);
};
export const updateAvatar = (data, id) => {
  return post(url.AVATAR_UPDATE + id, data);
};
export const deleteAvatar = (id) => {
  return del(url.AVATAR_DELETE + id);
};
export const changeAvatarStatus = (id, data) => {
  return post(url.AVATAR_STATUS + id, data);
};

export const totalCount = () => {
  return get(url.TOTAL_COUNT);
};

export const graphData = () => {
  return get(url.GRAPH_DATA);
};

//payout management
export const getPayOut = (data) => {
  return get(url.PAYOUT, data);
};

//analytics reportings
export const getAnalytics = (data) => {
  return get(url.ANALYTICS_REPORTING, data);
};
